<style>
#SettingsSnapWrapper .v-list__tile {
  height: auto !important;
}
#SettingsSnapWrapper #main__wrapper {
  padding-top: 30px;
}
#SettingsSnap .v--modal-box.v--modal {
  min-height: 200px !important;
  min-width: 500px !important;
}
</style>

<template>
  <Modal
    modalName="SettingsSnap"
    title="Ustawienia przyciągania"
    @saved="save"
    @opened="opened"
    :buttons="['save']"
  >
    <div id="SettingsSnapWrapper">
      <v-layout wrap align-center id="main__wrapper">
        <v-flex xs9>
          <v-slider
            v-model="tolerance"
            :max="50"
            :min="0"
            :step="1"
            append-icon="fiber_smart_record"
            prepend-icon="highlight_off"
          ></v-slider>
        </v-flex>
        <v-spacer/>
        <v-flex shrink xs2 style="height:68px">
          <v-text-field
            v-model="tolerance"
            class="mt-0"
            :max="50"
            :min="0"
            :step="1"
            hide-details
            single-line
            type="number"
          ></v-text-field>
        </v-flex>

        <v-expansion-panel v-if="userLayers.length > 0">
          <v-expansion-panel-content>
            <v-subheader class="font--primary" slot="header">Warstwy użytkownika</v-subheader>
            <v-card>
              <ul class="values__list">
                <li class="list__container--el" v-for="layer in userLayers" :key="layer.table">
                  <span>
                    <input
                      type="checkbox"
                      :id="layer.table"
                      :value="layer.select"
                      v-model="layer.select"
                    >
                    <label v-text="layer.name"></label>
                  </span>
                </li>
              </ul>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="tempLayers.length > 0">
          <v-expansion-panel-content>
            <v-subheader class="font--primary" slot="header">Warstwy tymczasowe</v-subheader>
            <v-card>
              <ul class="values__list">
                <li class="list__container--el" v-for="layer in tempLayers" :key="layer.id">
                  <span>
                    <input
                      type="checkbox"
                      :id="layer.id"
                      :value="layer.select"       
                      v-model="layer.select"
                    >
                    <label v-text="layer.name"></label><!--@change="layer.select = !layer.select"-->
                  </span>
                </li>
              </ul>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-layout>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

import { Vector as VectorLayer } from "ol/layer";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
//import filter from "lodash/filter";
//import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
//import some from "lodash/some";
//import isArray from "lodash/isArray";
import each from "lodash/each";
import get from "lodash/get";
mixin(_, {
  map,
  //filter,
  //includes,
  isEmpty,
  //some,
  //isArray,
  each,
  get : get,
  chain
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    Modal
  },
  data: () => ({
    tolerance: 15,

    userLayers: [],
    tempLayers: []
  }),
  computed: {
    toleranceOld() {
      return this.$store.getters.getSnapTolerance;
    },
    snapLayersOld() {
      return this.$store.getters.getSnapLayers;
    },

    userLayersMap() {
      return this.$store.getters.getUserLayers;
    },
    tempLayersMap() {
      return this.$store.getters.getTempLayers;
    },
  },
  methods: {
    opened() {
      this.tolerance = this.toleranceOld;

      let userLayers = {};
      if ("userLayers" in this.snapLayersOld) {
        userLayers = this.snapLayersOld.userLayers;
      }
      let tempLayers = {};
      if ("tempLayers" in this.snapLayersOld) {
        tempLayers = this.snapLayersOld.tempLayers;
      }

      this.userLayers = _.map(this.userLayersMap, (layer) => {
        const full_type = `user_layer_${layer.table}`;
        return {
          full_type,
          name : layer.name,
          select : _.get(userLayers, full_type, false)
        };
      });
      this.tempLayers = _.map(this.tempLayersMap, (layer) => {
        const full_type = `temp_layer_${layer.name}`;
        return {
          full_type,
          name : layer.name,
          select : _.get(tempLayers, full_type, false)
        };
      });
    },
    save() {
      this.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Proszę czekać, trwa zmiana ustawień przyciągania"
      );
      setTimeout(() => {
        let userLayers = {};
        if ("userLayers" in this.snapLayersOld) {
          userLayers = this.snapLayersOld.userLayers;
        }
        let tempLayers = {};
        if ("tempLayers" in this.snapLayersOld) {
          tempLayers = this.snapLayersOld.tempLayers;
        }

        _.each(this.userLayers, v => {
          userLayers[v.full_type] = v.select;
        });
        _.each(this.tempLayers, v => {
          tempLayers[v.full_type] = v.select;
        });

        this.$store.commit("setSnapLayers", {
          userLayers,
          tempLayers
        });
        this.$store.commit("setSnapTolerance", this.tolerance);
        this.$modal.hide("SettingsSnap");
      }, 500);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/edition/modals/SettingsSnap.vue